<div class="pane-mini" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <div *ngIf="content.length > 10" class="gallery-drag-scroll">
    <div class="pane-header" [class.mobile]="deviceService.isMobile()">
    <app-library-title [title]="blockTitle" [class.with-sorting]="_pane.show_sorting">
      <ng-container side>
        <span class="subtitle normal">{{ blockTitle?.subtitle | customLocale }}</span>
      </ng-container>
    </app-library-title>
    <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitle?.see_all_link" [pane]="_pane"></app-library-sorting>
    </div>

    <ng-template [ngIf]="content && isDragScrollEnabled">
      <div class="right-btn" (click)="moveRight()">
        <app-icon class="right-arrow" icon="drag-scroll-arrow"></app-icon>
      </div>

      <div class="left-btn" (click)="moveLeft()">
        <app-icon class="left-arrow" icon="drag-scroll-arrow"></app-icon>
      </div>
    </ng-template>

    <ng-template [ngIf]="content && content.length > 0">
      <ng-template [ngIf]="isDragScrollEnabled" [ngIfElse]="nav2">
        <cdk-virtual-scroll-viewport
          #scroller
          [itemSize]="itemSize"
          class="scroll-viewport"
          orientation="horizontal">
          <div *cdkVirtualFor="let groupItemContent of groupsContent; let i = index" class="scroll-item">
            <app-gallery-content-group [groupItemContent]="groupItemContent"
                                       [sizeCard]="sizeCard"
                                       (openCard)="onOpenCard($event)">
            </app-gallery-content-group>
          </div>
        </cdk-virtual-scroll-viewport>
      </ng-template>
      <ng-template #nav2>
        <div class="responsive-scroll-viewport">
          <div *ngFor="let groupItemContent of groupsContent; let i = index; trackBy: trackByFn" class="scroll-item">
            <app-gallery-content-group [groupItemContent]="groupItemContent"
                                       [sizeCard]="sizeCard"
                                       (openCard)="onOpenCard($event)">
            </app-gallery-content-group>
          </div>
        </div>
      </ng-template>
    </ng-template>
  </div>
</ng-template>

<app-modal *ngIf="!isSmallScreen && showModal"
           [canClose]="false"
           (closed)="onCloseModal($event)"
           [prevNext]="true"
           [reachedPrev]="reachedPrev"
           [reachedNext]="reachedNext"
           (togglePrev)="togglePrev($event)"
           (toggleNext)="toggleNext($event)">
  <app-modal-body>
    <app-content-card
      class="modal"
      [item_id]="item.id"
      [show]="openedCardIndex !== null"
      [canClose]="false"
      [inline]="false"
      [active]="false"
      [meta]="true"
      (close)="onCloseCard()">
    </app-content-card>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="isSmallScreen && showModal" (closed)="onCloseModal($event)">
  <app-mobile-modal-body>
    <div class="card">
      <app-content-card
        [item_id]="item.id"
        [show]="openedCardIndex !== null"
        [canClose]="false"
        [inline]="false"
        [active]="false"
        [meta]="true"
        [displayMode]="'content_page'"
        (close)="onCloseCard()">
      </app-content-card>
    </div>
  </app-mobile-modal-body>

  <app-mobile-modal-actions></app-mobile-modal-actions>
</app-mobile-modal>
